const GERMAN_STATES_OPTIONS = [
  { optionLabel: 'Baden-Württemberg', optionValue: 'Baden-Württemberg' },
  { optionLabel: 'Bayern', optionValue: 'Bayern' },
  { optionLabel: 'Berlin', optionValue: 'Berlin' },
  { optionLabel: 'Brandenburg', optionValue: 'Brandenburg' },
  { optionLabel: 'Bremen', optionValue: 'Bremen' },
  { optionLabel: 'Hamburg', optionValue: 'Hamburg' },
  { optionLabel: 'Hessen', optionValue: 'Hessen' },
  { optionLabel: 'Mecklenburg-Vorpommern', optionValue: 'Mecklenburg-Vorpommern' },
  { optionLabel: 'Niedersachsen', optionValue: 'Niedersachsen' },
  { optionLabel: 'Nordrhein-Westfalen', optionValue: 'Nordrhein-Westfalen' },
  { optionLabel: 'Rheinland-Pfalz', optionValue: 'Rheinland-Pfalz' },
  { optionLabel: 'Saarland', optionValue: 'Saarland' },
  { optionLabel: 'Sachsen', optionValue: 'Sachsen' },
  { optionLabel: 'Sachsen-Anhalt', optionValue: 'Sachsen-Anhalt' },
  { optionLabel: 'Schleswig-Holstein', optionValue: 'Schleswig-Holstein' },
  { optionLabel: 'Thüringen', optionValue: 'Thüringen' },
]

export default GERMAN_STATES_OPTIONS
